import React, { useState } from 'react';
import TextInput from 'components/TextInput/TextInput';
import Space from 'components/Space/Space';
import Button from 'components/Button/Button';
import { submitContact } from 'api/website';
import {
	ErrorText,
	FormError,
	Sent,
	SentTitle,
	SentText,
} from './styled';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validate = (values) => {
	const errors = {};
	if (!values.name.trim()) errors.name = 'Required';
	if (!values.email.trim()) errors.email = 'Required';
	else if (!EMAIL_PATTERN.test(values.email)) {
		errors.email = 'Enter a valid email address';
	}
	if (!values.message.trim()) errors.message = 'Required';
	return errors;
};

const ContactForm = (props) => {
	const [values, setValues] = useState({ name: '', email: '', message: '' });
	const [errors, setErrors] = useState({});
	const [submitting, setSubmitting] = useState(false);
	const [submitError, setSubmitError] = useState('');
	const [sent, setSent] = useState(false);

	const setValue = (name, value) => {
		setValues((current) => ({ ...current, [name]: value }));
		setErrors((current) => {
			if (!current[name]) return current;
			const next = { ...current };
			delete next[name];
			return next;
		});
	};

	const onSubmit = async (event) => {
		event.preventDefault();
		const found = validate(values);
		setErrors(found);
		if (Object.keys(found).length > 0) return;

		setSubmitting(true);
		setSubmitError('');
		try {
			await submitContact(values);
			setSent(true);
		} catch (err) {
			setSubmitError(
				'Could not send your message. Please try again, or email us directly.',
			);
		} finally {
			setSubmitting(false);
		}
	};

	if (sent) {
		return (
			<Sent {...props}>
				<SentTitle>Thanks — we got your message.</SentTitle>
				<SentText>
					We will get back to you shortly.
				</SentText>
			</Sent>
		);
	}

	return (
		<form {...props} onSubmit={onSubmit} noValidate>
			<TextInput
				label='Name'
				placeholder='John Doe'
				value={values.name}
				error={!!errors.name}
				onChange={(e) => setValue('name', e.target.value)}
			/>
			{errors.name ? <ErrorText>{errors.name}</ErrorText> : null}
			<Space />
			<TextInput
				label='Email'
				placeholder='john.doe@example.com'
				value={values.email}
				error={!!errors.email}
				onChange={(e) => setValue('email', e.target.value)}
			/>
			{errors.email ? <ErrorText>{errors.email}</ErrorText> : null}
			<Space />
			<TextInput
				label='Message'
				textarea
				placeholder='I want to know more about Flass.'
				value={values.message}
				error={!!errors.message}
				onChange={(e) => setValue('message', e.target.value)}
			/>
			{errors.message ? <ErrorText>{errors.message}</ErrorText> : null}
			<Space />
			{submitError ? <FormError>{submitError}</FormError> : null}
			<Button size='fit' type='submit' disabled={submitting}>
				{submitting ? 'Sending…' : 'Send'}
			</Button>
		</form>
	);
};

export default ContactForm;
